import { createFileRoute } from "@tanstack/react-router";

import { RunsPage } from "../../../workspaces/training/pages/RunsPage";

interface TrainingRunSearch {
  readonly state?: string;
  readonly runType?: string;
  readonly group?: string;
  readonly q?: string;
  readonly page?: number;
}

export const Route = createFileRoute("/_console/p/$org/$project/training/runs/")({
  validateSearch: (search: Record<string, unknown>): TrainingRunSearch => ({
    state: typeof search.state === "string" ? search.state : undefined,
    runType: typeof search.runType === "string" ? search.runType : undefined,
    group: typeof search.group === "string" ? search.group : undefined,
    q: typeof search.q === "string" ? search.q : undefined,
    page:
      typeof search.page === "number" && Number.isFinite(search.page) && search.page > 0
        ? Math.floor(search.page)
        : undefined,
  }),
  component: RunsPage,
});
